module.exports = __webpack_public_path__ + "static/media/lift_lab_logo.349f2471.jpg";